import { activeModule } from "../providers/active-module";
import * as CoreImages from "./src/shared/assets/images/images";
import { Images as FourTimeImages } from "../4time/images";
import * as IrsKomImages from "../IrsKom/images";
import * as Parhato2Images from "../parhato2/images";

const modulesImages: Record<string, any> = {
  "4TIME": FourTimeImages,
  IRSKOM: IrsKomImages,
  PARHATO2: Parhato2Images,
};

let Images = CoreImages;

const moduleName = activeModule;
if (modulesImages[moduleName]) {
  Images = { ...CoreImages, ...modulesImages[moduleName] };
}

export const {
  logo,
  placeholderLogo,
  basket,
  basketActive,
  category,
  categoryActive,
  home,
  homeActive,
  person,
  personActive,
  wish,
  wishActive,
  roundLogo,
} = Images;

export default Images;
